import React, {useState} from "react";
import {Button, ButtonSize, ButtonType, Dropdown, IconSize, IDropdownItem} from "@renta-apps/renta-react-components";
import Localizer from "@/localization/Localizer";
import styles from "./FiltersAndSort.module.scss";
import {EquipmentsFiltersSortAndPagination} from "../EquipmentsNew";
import FiltersModal from "./FiltersModal";
import FiltersForm from "@/pages/ConstructionSiteDetails/EquipmentsNew/FiltersAndSort/FiltersForm";

export interface IFiltersAndSortProps {
    constructionSiteId: string;
    onGetReportModalOpen?: () => void;
    params: EquipmentsFiltersSortAndPagination;
    onParamValueChange: (change: Partial<EquipmentsFiltersSortAndPagination>) => void;
}

const FiltersAndSort: React.FC<IFiltersAndSortProps> = ({constructionSiteId, params, onParamValueChange, onGetReportModalOpen}) => {
    const [filtersModalVisible, setFiltersModalVisible] = useState(false);

    const sortOrderItems: IDropdownItem[] = [
        {name: Localizer.enumSortDirectionAsc, value: "Asc"},
        {name: Localizer.enumSortDirectionDesc, value: "Desc"},
    ];

    const sortByItems: IDropdownItem[] = [
        {name: Localizer.constructionSiteDetailsEquipmentTabSortByName, value: "Name"},
        {name: Localizer.constructionSiteDetailsEquipmentTabSortByProductGroup, value: "ProductGroupName"},
        {name: Localizer.constructionSiteDetailsEquipmentTabSortByCategory, value: "CategoryName"},
        {name: Localizer.constructionSiteDetailsEquipmentTabSortByRentalStartDate, value: "RentalStartDate"},
        {name: Localizer.constructionSiteDetailsEquipmentTabSortByRentalEndDate, value: "RentalEndDate"},
        {name: Localizer.constructionSiteDetailsEquipmentTabSortByIdle, value: "IdleDays"},
        {name: Localizer.constructionSiteDetailsEquipmentTabSortByAlerts, value: "AlertsCount"},
        {name: Localizer.constructionSiteDetailsEquipmentTabSortByBattery, value: "BatteryLevel"},
        {name: Localizer.constructionSiteDetailsEquipmentTabSortByFuel, value: "FluidLevel"},
    ];

    return (
        <div className={styles.container}>
            <FiltersForm constructionSiteId={constructionSiteId}
                         params={params}
                         onParamValueChange={onParamValueChange}
                         filtersModalVisible={filtersModalVisible}
                         onFiltersModalVisibilityChange={(visible) => setFiltersModalVisible(visible)}
            />
            <div className={styles.sortRow}>
                <Dropdown id="equipments-sort-by"
                          items={sortByItems}
                          selectedItem={params.sortBy}
                          className={styles.formField}
                          label={Localizer.fleetMonitoringPageFiltersLabelsSortBy}
                          onChange={(item: IDropdownItem) => onParamValueChange({sortBy: item.value!.toString()})}
                />
                <Dropdown id="equipments-sort-order"
                          items={sortOrderItems}
                          selectedItem={params.sortOrder}
                          className={styles.formField}
                          label={Localizer.fleetMonitoringPageFiltersLabelsSortOrder}
                          onChange={(item: IDropdownItem) => onParamValueChange({sortOrder: item.value!.toString()})}
                />
                <div className={styles.buttonContainer}>
                    <Button className={styles.getReportButton}
                            type={ButtonType.Secondary}
                            size={ButtonSize.Medium}
                            id={"getReportButton"}
                            iconLeft={{name: "download", color: "#FE5000", size: IconSize.Medium}}
                            onClick={onGetReportModalOpen}
                    >
                        {Localizer.constructionSiteDetailsEquipmentTabGetReportButton}
                    </Button>
                </div>
            </div>
            {filtersModalVisible && (
                <FiltersModal params={params}
                              constructionSiteId={constructionSiteId}
                              onClose={() => setFiltersModalVisible(false)}
                              onParamValueChange={(change: Partial<EquipmentsFiltersSortAndPagination>) => onParamValueChange({...params, ...change})}
                />
            )}
        </div>
    );
};

export default FiltersAndSort;